<template>
    <div class="quick-menu">
        <div class="quick-menu__inner">
            <a href="javascript:;" class="quick-menu__item item1" @click="showPopup">
                <div class="icon">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="quick-icon" fill-rule="evenodd" clip-rule="evenodd"
                            d="M4.66667 7.00001H23.3333V11.6667H4.66667V7.00001ZM3.5 11.6667V7.00001V5.83334H4.66667H23.3333H24.5V7.00001V11.6667V12.8333V23.3333V24.5H23.3333H4.66667H3.5V23.3333V12.8333V11.6667ZM23.3333 12.8333H4.66667V23.3333H23.3333V12.8333Z"
                            fill="white" />
                        <path class="quick-icon" d="M8.16602 3.5H9.33268V7H8.16602V3.5Z" fill="white" />
                        <path class="quick-icon" d="M18.666 3.5H19.8327V7H18.666V3.5Z" fill="white" />
                        <path class="quick-icon"
                            d="M17.8347 16.0009C17.824 16.5563 17.5849 17.2184 17.1647 17.863C16.7453 18.5028 16.1616 19.1053 15.5151 19.5568C14.8709 20.0087 14.1048 20.3529 13.3592 20.5286C12.61 20.7049 11.907 20.7027 11.3805 20.5225C10.8755 20.3496 10.5349 20.0192 10.3962 19.5702C10.306 19.278 10.4174 18.9628 10.673 18.7843L11.5477 18.1734C11.7227 18.0513 11.9387 18.0141 12.1431 18.0681C12.3453 18.1217 12.5104 18.2621 12.5975 18.4509C12.6014 18.4563 12.6028 18.4614 12.6053 18.4678L12.6836 18.6789C13.0226 18.6228 13.7646 18.4537 14.4206 17.9895C15.0774 17.5267 15.4904 16.8893 15.6598 16.5903L15.4895 16.4455C15.4857 16.44 15.4801 16.4378 15.4763 16.4324C15.3277 16.2865 15.2528 16.0832 15.2711 15.8735C15.2884 15.6625 15.3991 15.4716 15.5741 15.3494L16.4488 14.7385C16.703 14.561 17.0373 14.565 17.2809 14.748C17.6561 15.0318 17.849 15.4653 17.8384 16.0004L17.8347 16.0009Z"
                            fill="white" />
                    </svg>
                </div>
                <h3>간편예약</h3>
            </a>
            <a href="javascript:;" class="quick-menu__item item2" @click="goReservation">
                <div class="icon">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="quick-icon" fill-rule="evenodd" clip-rule="evenodd"
                            d="M4.66667 6.99998H23.3333V11.6666H4.66667V6.99998ZM3.5 11.6666V6.99998V5.83331H4.66667H23.3333H24.5V6.99998V11.6666V12.8333V23.3333V24.5H23.3333H4.66667H3.5V23.3333V12.8333V11.6666ZM23.3333 12.8333H4.66667V23.3333H23.3333V12.8333Z"
                            fill="white" />
                        <path class="quick-icon" d="M8.16602 3.5H9.33268V7H8.16602V3.5Z" fill="white" />
                        <path class="quick-icon" d="M18.666 3.5H19.8327V7H18.666V3.5Z" fill="white" />
                        <path class="quick-icon" fill-rule="evenodd" clip-rule="evenodd" d="M12.9653 17.8875L16.5306 14.73L17.3041 15.6034L12.9653 19.4459L10.6973 17.4373L11.4708 16.5639L12.9653 17.8875Z" fill="white" />
                    </svg>

                </div>
                <h3>진료예약</h3>
            </a>
            <router-link :to="$route.path.indexOf('center') > -1 ? '/kr/centerList' : '/kr/clinicList'" class="quick-menu__item item3">
                <div class="icon">
                    <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
                        <rect class="quick-icon" x="4.66602" y="6.6" width="18.6667" height="2" fill="white" />
                        <rect class="quick-icon" x="4.66602" y="13.6" width="18.6667" height="2" fill="white" />
                        <rect class="quick-icon" x="4.66602" y="20.6" width="18.6667" height="2" fill="white" />
                    </svg>
                </div>
                <h3>{{$route.path.indexOf('center') > -1 ? '전체센터' : '전체클리닉'}}</h3>
            </router-link>
            <div class="circle"></div>
        </div>
    </div>
    <kr_popup_certification v-if="popupVisible" @cancelNameCheck="hidePopup"/>
    <kr_SimpleRsvPopup :popupVisible="simpleVisible" :info="info" @hide-popup="hidePopup"/>
</template>

<script>
    export default {
        props: {
            info: ''
        },
        data() {
            return {
                popupVisible: false,
                simpleVisible: false,
            }
        },
        methods: {
            showPopup(){
                this.simpleVisible = true
            },
            hidePopup() {
                this.popupVisible = false;
                this.simpleVisible = false;
            },
            checkSuccess(data){
                if(data.iReturn === 0 && data.ptNo !== '' && data.ptNo !== null){
                    this.hidePopup()
                    this.$store.state.reserveStore.normalReserve = {doctorDept: this.info}
                    this.$store.state.patInfoStore = {}
                    this.$router.push({path: '/kr/reserve/reservation'})
                }else{
                    alert(data.sMessage)
                }
            },
            goReservation(){
                if(!this.$store.getters.getStatus){
                    alert('로그인 후 이용이 가능합니다.')

                    let url = '/kr/login'
                    this.$router.push(url);
                }else{
                    this.$store.commit('setNiceType', '')
                    this.$store.state.patInfoStore = {}
                    
                    if(this.$commonUtils.isEmpty(this.$store.state.myInfoStore.ptNo)){
                        this.popupVisible = true
                    }else{
                        this.$store.state.reserveStore.normalReserve = {doctorDept: this.info}
                        this.$router.push('/kr/reserve/reservation')
                    }
                }
            },
            observeFooter() {
                const cont = document.querySelector('.container');
                const quickMenu = document.querySelector('.quick-menu');
                // IntersectionObserver 콜백 함수
                const callback = (entries) => {
                    entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                // cont의 하단이 뷰포트에 보이면 on 클래스 추가
                                quickMenu.classList.add('on');
                            } else {
                                // cont의 하단이 뷰포트에서 벗어나면 on 클래스 제거
                                quickMenu.classList.remove('on');
                            }
                    });
                };

                // IntersectionObserver 생성
                this.observer = new IntersectionObserver(callback, {
                    root: null, // 뷰포트를 기준으로 감지
                    threshold: 1.0, // cont의 하단이 완전히 보일 때 이벤트 트리거
                });

                // cont 요소의 하단을 감지 대상으로 설정
                const contBottom = document.createElement('div');
                contBottom.style.position = 'absolute';
                contBottom.style.bottom = '0';
                contBottom.style.width = '100%';
                contBottom.style.height = '1px'; // 높이는 필요에 따라 조정
                cont.appendChild(contBottom);
                this.observer.observe(contBottom);
            },
        },
        mounted() {

            this.observeFooter();


            const itemsWrap = document.querySelector('.quick-menu');
            const itemsWrapInner = document.querySelector('.quick-menu__inner');
            const items = document.querySelectorAll('.quick-menu__item');
            const circle = document.querySelector('.circle');

            items.forEach(item => {
                item.addEventListener('mouseover', () => {
                    const itemRect = item.getBoundingClientRect();
                    const quickMenuRect = document.querySelector('.quick-menu').getBoundingClientRect();

                    // circle의 위치를 해당 item으로 이동
                    circle.style.top = `${itemRect.top - quickMenuRect.top + itemRect.height / 20}px`;

                });
            });
            itemsWrapInner.addEventListener('mouseover', () => {
                itemsWrap.classList.add('active');
            });

            // 마우스가 나갈 시 active 클래스 제거
            itemsWrap.addEventListener('mouseout', () => {
                itemsWrap.classList.remove('active');
            });

            window.addEventListener("message", (event) => {
                try {

                    if (event.data && (event.data.source === "react-devtools-content-script" || event.data.key === "__VUE_DEVTOOLS_VUE_DETECTED_EVENT__")) {
                        return;
                    }

                    const receivedData = JSON.parse(event.data); // JSON 파싱
                    if (receivedData.callFunction === "checkSuccess") {
                        this.checkSuccess(receivedData.data); // 데이터 전달
                    }
                } catch (e) {
                    console.error("Invalid JSON data received:", e);
                }
            });
        },
    }
</script>